import _ from 'lodash';

import NotificationConstants from './NotificationConstants';

export function notifications(state = [], action) {
    switch (action.type) {
        case NotificationConstants.NOTIFICATION_ADDED:
            return [
                ...state,
                {
                    ...action.payload
                }
            ];
            break;
        case NotificationConstants.NOTIFICATION_REMOVED:
            return _.filter(state, notification => notification.id !== action.payload.id );
            break;
        default:
            return state;
    }
}
